import { runWithAdal } from "react-adal";
import { authContext } from "./adalConfig";
import "font-awesome/css/font-awesome.min.css";

runWithAdal(authContext, () => {
    // eslint-disable-next-line
    require("./indexApp.js");
});
